import { defaultVK } from "@hid/define/define_keys"
import { type KK, OutputMode, type Output, KIO } from "../../define/define"
import { SetKeyType, type PostSetKey } from "../../define/request"
import { deviceManager } from "../../device/device_manager"
import { dataProfileManage } from "../../snapshot/profile"
import { markKmeKeys } from "./handle_set_magnet_senior_key"
import { MagnetSeniorType } from "@libs/types/enum"

export const handleSetkey = async (data: PostSetKey) => {
    const config = dataProfileManage().dataProfile
    const changeKeys = Object.keys(data.Key)
    changeKeys.forEach((k: string) => {
        const kk = Number(k) as KK

        let setType = OutputMode.Key
        let extension: number[] = []
        if (data.KeyType == SetKeyType.KeyFire) {
            setType = OutputMode.Fire
            extension = data.KeyFire[kk]
        } else if (data.Key[kk] == defaultVK) {
            let resetKIO = { Input: { KK: kk, WithFN: data.IsFn, WithModifier: data.KeyModifier[kk] ? data.KeyModifier[kk] : [] }, Output: { Mode: OutputMode.Key, VK: defaultVK } } as KIO
            const findIndex = config.Keys.findIndex((item) => item.Input.KK == kk && item.Input.WithFN == data.IsFn)
            if (findIndex > -1) {
                resetKIO = config.Keys[findIndex]
            }
            dataProfileManage().ResetKeys.push(resetKIO)
        }

        markKmeKeys(kk, MagnetSeniorType.SeniorKeyTypeNone, config, data.IsFn)
        const findIndex = config.Keys.findIndex((item) => item.Input.KK == kk && item.Input.WithFN == data.IsFn)
        if (findIndex > -1) {
            config.Keys.splice(findIndex, 1)
        }

        const mapkey = {
            Input: {
                KK: kk,
                WithFN: data.IsFn,
                WithModifier: data.KeyModifier[kk] ? data.KeyModifier[kk] : [],
            },
            Output: {
                Mode: setType,
                VK: data.Key[kk],
                Extension: extension
            } as Output
        }
        config.Keys.push(mapkey)

    })
    dataProfileManage().save()

    return deviceManager.deviceDriver.syncKeys()
}
